import React, { FC, useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  List,
  Card,
  Input,
  Button,
  Checkbox,
  Select,
  Collapse,
} from "antd";
import { ReactSVG } from "react-svg";
import "./index.scss";
import AddCadQuestionModal from "../CAD/AddCadQuestionModal";
import {
  SocketTopics,
  UserTopics,
  CADSectionTopics,
} from "../../../constants/enums";
import {
  getCADProjectSectionPath,
  getCADSectionPath,
  getCADCustomerSectionPath
} from "../../../hooks/socketConstants";
import useSocketActions from "../../../hooks/socketActions";
import { pushNotification } from "utils/notifications";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import csvDownload from "json-to-csv-export";

import { getParameterByName } from "../../../common/helpers";
import RenderFields from "../../../common/RenderFields";

const sectionTypes: any = {
  Account: "Account",
  Why: "Why",
  Where: "Where",
  Who: "Who",
  When: "When",
  What: "What",
  Custom: "",
};

export const DeleteQuestionareButton: FC<{ onClick; label: string }> = ({
  onClick,
  label,
}) => {
  return (
    <a key="list-loadmore-edit">
      <ReactSVG
        className="sz-20 action-buttons delete-btn mr-2"
        src="/images/delete-icon.svg"
        title={label}
        onClick={onClick}
      />
    </a>
  );
};

export const AddQuestionareButton: FC<{ onClick; label: string }> = ({
  onClick,
  label,
}) => {
  return (
    <a key="list-loadmore-edit">
      <ReactSVG
        className="sz-20 action-buttons mr-2"
        src="/images/add-icon.svg"
        title={label}
        onClick={onClick}
      />
    </a>
  );
};

export const EditQuestionaireButton: FC<{ onClick: any; label: string }> = ({
  onClick,
  label,
}) => {
  return (
    <a key="list-loadmore-edit">
      <ReactSVG
        className="sz-14 action-buttons mr-2"
        src="/images/edit-icon.svg"
        title={label}
        onClick={onClick}
      />
    </a>
  );
};

export const ListCols: FC<{
  item: any;
  editQuestion: any;
  deleteQuestion: any;
}> = ({ item, editQuestion, deleteQuestion }) => {
  return (
    <Row className="w-100">
      {item.Cols.map((col, colIndex) => {
        return (
          <Col
            span={col.ColSize}
            className="d-flex w-100 flex-column align-items-center justify-content-start tiles mt-3"
            key={colIndex}
            style={{
              marginLeft: colIndex === 0 ? -5 * (item.Cols.length - 1) : 0,
              marginRight: colIndex !== item.Cols.length - 1 ? 5 : 0,
            }}
          >
            <Row className="d-flex w-100 justify-content-end">
              <EditQuestionaireButton
                label="Edit Question"
                onClick={() => editQuestion(colIndex)}
              />
              <DeleteQuestionareButton
                label="Delete Question"
                onClick={() => deleteQuestion(colIndex)}
              />
            </Row>
            <div className="w-100">
              <RenderFields data={col} />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

const { Panel } = Collapse;

export const ListRows: FC<{
  item: any;
  addNewQuestion: any;
  addNewRow: any;
  deleteRow: any;
  editQuestion: any;
  deleteQuestion: any;
  deleteSection: any;
  isMultiClick: any;
}> = ({
  item,
  addNewQuestion,
  addNewRow,
  deleteRow,
  editQuestion,
  deleteQuestion,
  deleteSection,
  isMultiClick,
}) => {
  const [sectionName, setSectionName] = useState<string>(item.sectionName);
  const fSectionName = item.sectionName;
  const { Custom, ...fixedSectionsType } = sectionTypes;
  return (
        <Row>
          {item.Rows.map((row, rowIndex) => {
            return (
              <div
                className="w-100 d-flex tiles mt-3"
                key={rowIndex}
                style={{
                  border: 0,
                }}
              >
                <Row
                  className=" d-flex tiles w-100 mt-3"
                  key={rowIndex}
                  style={{
                    background: "#edf0f5",
                    border: 0,
                    borderRadius: 10,
                    boxShadow: "-6px 0px 10px #ffffff, 8px 8px 10px #dfe5ee",
                  }}
                >
                  {!row.Cols.length ? (
                    <Row className="d-flex w-100 justify-content-center">
                      <AddQuestionareButton
                        label="Add New Col"
                        onClick={() => addNewQuestion(rowIndex)}
                      />
                      <h5>Click to add new question</h5>
                    </Row>
                  ) : (
                    <div className="d-flex w-100 justify-content-end">
                      <Checkbox
                        className="mr-2"
                        checked={row.isMulti}
                        defaultChecked={false}
                        onChange={(e) =>
                          isMultiClick(rowIndex, e.target.checked)
                        }
                      >
                        is Multi ?
                      </Checkbox>
                      <AddQuestionareButton
                        label="Add New Col"
                        onClick={() => addNewQuestion(rowIndex)}
                      />
                    </div>
                  )}
                  <ListCols
                    item={row}
                    editQuestion={(colIndex) =>
                      editQuestion(rowIndex, colIndex)
                    }
                    deleteQuestion={(colIndex) =>
                      deleteQuestion(rowIndex, colIndex)
                    }
                  />
                </Row>

                <div className="d-flex flex-column align-items-center ml-3">
                  <AddQuestionareButton
                    label="Add New Row"
                    onClick={() => addNewRow(rowIndex)}
                  />
                  <DeleteQuestionareButton
                    label="Delete Row"
                    onClick={() => deleteRow(rowIndex)}
                  />
                </div>
              </div>
            );
          })}
        </Row>
      // </Panel>
    // </Collapse>
  );
};

const CustomerFormModal: FC<{ socket: ISocket }> = ({ socket }) => {
  const [config, setConfig] = useState<ICADSection[]>([]);
  const { sectionList } = useSelector((state: RootState) => state.auth);
  const [isShowNewQuestionModal, setIsShowNewQuestionModal] =
    useState<any>(false);
  const [isShowAddNewSectionModal, setIsShowAddNewSectionModal] =
    useState<any>(false);

  const [isEditQuestion, setIsEditQuestion] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<{
    sectionIndex: number;
    rowIndex: number;
    colIndex: number;
    limit: number;
  }>({ sectionIndex: 0, rowIndex: 0, limit: 0, colIndex: 0 });
  const [initLoading, setInitLoading] = useState<boolean>(true);

  const { getUserRequestPayload, updateUserRequestPayload } =
    useSocketActions();

  const addNewSection = (sectionName: any) => {
    setIsShowAddNewSectionModal(false);
    config.push({
      sectionName: sectionName,
      Rows: [
        {
          isMulti: false,
          Cols: [],
        },
      ],
    });
    setConfig([...config]);
  };

  const addNewRow = (sectionIndex: number = 0, rowIndex: number = 0) => {
    config[sectionIndex].Rows.splice(rowIndex + 1, 0, {
      Cols: [],
      isMulti: false,
    });
    setConfig([...config]);
  };

  const deleteRow = (sectionIndex, rowIndex) => {
    config[sectionIndex].Rows.splice(rowIndex, 1);
    setConfig([...config]);
  };

  const addNewQuestionaire = (data) => {
    setIsShowNewQuestionModal(!isShowNewQuestionModal);

    if (!isEditQuestion) {
      config[selectedItem.sectionIndex].Rows[selectedItem.rowIndex].Cols.push({
        ...data,
        label: data.label,
        value: "",
      });
    } else {
      config[selectedItem.sectionIndex].Rows[selectedItem.rowIndex].Cols[
        selectedItem.colIndex
      ] = {
        ...data,
        label: data.label,
        value: "",
      };
    }

    setConfig([...config]);
  };

  useEffect(() => {
    const projectId = getParameterByName("projectId");
    const list =
      projectId && projectId !== ""
        ? sectionList[projectId] || []
        : sectionList;
    setConfig(list);
  }, [sectionList]);

  useEffect(() => {
    if (socket.client) {
      const projectId = getParameterByName("projectId");
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.SearchInUser,
        getUserRequestPayload(
          getParameterByName("userId"),
          "$",
          getCADCustomerSectionPath()
        ),
        CADSectionTopics.GetSectionList,
        getParameterByName("serviceId")
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        CADSectionTopics.GetSectionList,
        () => {
          setInitLoading(false);
        }
      );
    }
  }, [socket.client]);

  const saveCADSectionList = () => {
    setInitLoading(true);
    // const projectId = getParameterByName("projectId");
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.UpdateUser,
      updateUserRequestPayload(
        getParameterByName("userId"),
        "replace",
        getCADCustomerSectionPath(),
        [...config]
      ),
      CADSectionTopics.UpdateSectionList,
      getParameterByName("serviceId")
    );
    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      CADSectionTopics.UpdateSectionList,
      (data) => {
        setInitLoading(false);
        pushNotification(
          "CAD Sections Updated.",
          "successs",
          "TOP_CENTER",
          1000
        );
      }
    );
  };

  const generateCSVFile = () => {
    const headers: string[] = ["title", "location-lat", "location-long"];
    config.forEach((section: any) => {
      section.Rows.forEach((row: any) => {
        row.Cols.forEach((col: any) => {
          headers.push(col.name);
        });
      });
    });
    const dataToConvert = {
      data: [],
      filename: "event_template",
      delimiter: ",",
      headers: headers,
    };
    csvDownload(dataToConvert);
  };

  return (
    <Modal
      title=""
      visible={true}
      width="100%"
      className="beam-modal-cad survey-modal"
      footer={[]}
      closable={false}
    >
      {isShowNewQuestionModal && (
        <Modal
          visible={true}
          onOk={() => {}}
          onCancel={() => {
            setIsShowNewQuestionModal(!isShowNewQuestionModal);
          }}
          width="480px"
          className="beam-modal-cad"
          footer={[]}
          destroyOnClose={true}
          closable={true}
        >
          <AddCadQuestionModal
            headerTitle="Choose the Questionaire Type:"
            handleCancel={() =>
              setIsShowNewQuestionModal(!isShowNewQuestionModal)
            }
            onCreate={(item) => addNewQuestionaire(item)}
            data={
              config[selectedItem.sectionIndex].Rows[selectedItem.rowIndex]
                .Cols[selectedItem.colIndex]
            }
            maxLimit={selectedItem.limit}
            isEditQuestion={isEditQuestion}
          />
        </Modal>
      )}

      {isShowAddNewSectionModal && (
        <Modal
          visible={isShowAddNewSectionModal}
          onOk={() => {}}
          closable={true}
          onCancel={() => {
            setIsShowAddNewSectionModal(!isShowAddNewSectionModal);
          }}
          width="480px"
          className="beam-modal-cad"
          footer={[]}
          destroyOnClose={true}
        >
          <Row>
            <span className="col-label">Select Type of Section</span>
          </Row>
          <Row className="mt-2">
            {Object.entries(sectionTypes).map(([key, value]) => {
              return (
                <Col span={8} key={`${key}-${value}`}>
                  <Button
                    className="beam-btn cover mt-2 mb-2 section-type-btn"
                    onClick={() => {
                      addNewSection(value);
                    }}
                  >
                    {key}
                  </Button>
                </Col>
              );
            })}
          </Row>
        </Modal>
      )}

      {/* <Row className="d-flex justify-content-space-between">
        <Button
          className="beam-btn green-btn cover"
          onClick={() => setIsShowAddNewSectionModal(true)}
        >
          Add Section
        </Button>
        <Button
          className="beam-btn export mb-0 mb-md-2 mr-3 mr-md-0 h-50"
          onClick={() => generateCSVFile()}
        >
          <ReactSVG src="/images/export-csv.svg"></ReactSVG>
        </Button>
      </Row> */}

      {/* <Card className="filter-card"> */}
        <List
          className="demo-loadmore-list  cad-form-modal"
          itemLayout="horizontal"
          dataSource={config}
          renderItem={(item, sectionIndex) => (
            <React.Fragment>
              <ListRows
                item={item}
                deleteSection={() => {
                  config.splice(sectionIndex, 1);
                  setConfig([...config]);
                }}
                isMultiClick={(rowIndex, checked) => {
                  config[sectionIndex].Rows[rowIndex].isMulti = checked;
                  setConfig([...config]);
                }}
                editQuestion={(rowIndex, colIndex) => {
                  const limit =
                    24 -
                    config[sectionIndex].Rows[rowIndex].Cols.reduce(
                      (prevVal, currVal) => prevVal + currVal.ColSize,
                      0
                    ) +
                    config[sectionIndex].Rows[rowIndex].Cols[colIndex].ColSize;
                  setSelectedItem({
                    sectionIndex,
                    rowIndex,
                    colIndex,
                    limit,
                  });
                  setIsEditQuestion(true);
                  setIsShowNewQuestionModal(true);
                }}
                deleteQuestion={(rowIndex, colIndex) => {
                  config[sectionIndex].Rows[rowIndex].Cols.splice(colIndex, 1);
                  setConfig([...config]);
                }}
                addNewQuestion={(rowIndex) => {
                  setIsShowNewQuestionModal(true);
                  setIsEditQuestion(false);
                  const limit =
                    24 -
                    config[sectionIndex].Rows[rowIndex].Cols.reduce(
                      (prevVal, currVal) => prevVal + currVal.ColSize,
                      0
                    );

                  setSelectedItem({
                    sectionIndex,
                    rowIndex,
                    colIndex: 0,
                    limit,
                  });
                }}
                addNewRow={(rowIndex) => addNewRow(sectionIndex, rowIndex)}
                deleteRow={(rowIndex) => deleteRow(sectionIndex, rowIndex)}
              ></ListRows>
            </React.Fragment>
          )}
        />
      {/* </Card> */}
      <Row className="d-flex justify-content-end mt-4">
        <Button
          className="beam-btn green-btn cover"
          onClick={saveCADSectionList}
        >
          Save
        </Button>
      </Row>
    </Modal>
  );
};

export default CustomerFormModal;
